import { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: 'edit',
    name: 'manage.user.edit',
    component: () => import('@/views/control-panel/manage/users/user/Edit.vue'),
  },
]

export default routes
